import { ALL_ACTION, RULE_STATUS_ALL } from './flight-rule-ui';
import { ContentType, JourneyCarrier } from './journey';

export interface JourneySearchCriteria {
  rule: {
    id?: string;
    organization?: string;
    partitionId?: string;
    name?: string;
    active?: boolean;
    action?: string;
  };

  applicability?: {
    pointOfSale?: {
      names: string[];
    };
    marketPairs?: {
      firstMarket?: {
        names: string[];
      };
      secondMarket?: {
        names: string[];
      };
    };
    carriers?: string[];
    contentTypes?: ContentType[];
  };

  content?: {
    subRules: {
      applicability: {
        carrier: JourneyCarrier;
      };
    }[];
  };

  enableFullTextSearch?: boolean;
}

export interface JourneySearchCriteriaUi {
  rule: {
    id?: string;
    organization: string;
    name?: string;
    ruleStatus: string;
    actionType: string;
  };
  applicability?: {
    pointOfSaleNames: string[];
    firstMarketNames: string[];
    secondMarketNames: string[];
    carrierCode?: string[];
    operatingCarrier?: string[];
    marketingCarrier?: string[];
    contentTypes: ContentType[];
  };
  enableFullTextSearch?: boolean;
}

export const initialFlightRuleSearchCriteria: JourneySearchCriteriaUi = {
  rule: {
    id: '',
    name: '',
    organization: '',
    ruleStatus: RULE_STATUS_ALL,
    actionType: ALL_ACTION
  },
  applicability: {
    pointOfSaleNames: [],
    firstMarketNames: [],
    secondMarketNames: [],
    carrierCode: [],
    operatingCarrier: [],
    marketingCarrier: [],
    contentTypes: []
  }
};
